export const minPlayersForRounds = (rounds: number): number => {
  return Math.pow(2, rounds);
};

minPlayersForRounds(0)
